import React from 'react';
import { View, Platform } from 'react-native';

/** In-app host for the review checklist at /review.html */
export function ReviewNotes() {
  if (Platform.OS !== 'web') {
    return <View style={{ flex: 1, backgroundColor: '#111318' }} />;
  }
  return (
    <View style={{ flex: 1, minHeight: 0, backgroundColor: '#111318' }}>
      <iframe
        title="VRC review checklist"
        src="/review.html"
        style={{ width: '100%', height: '100%', border: 'none', minHeight: '70vh', background: '#111318' }}
      />
    </View>
  );
}
